<template>
  <div class="int-order-review">
    <progress-bar :activeIndex="activeIndex" />
    <div class="container" v-loading="loading">
      <div class="info-panel">
        <div v-if="activeIndex == 2">
          <div style="position: relative;">
            <OrderInfoCard :orderInfo="orderData.orderInfo || {}" />
            <div class="cancel-order-btn" @click="gotoCancelOrder" v-if="orderData.orderInfo && orderData.orderInfo.orderStatus == 'WP'">取消</div>
          </div>
          <PassengerInfoCard :passengers="orderData.passengers" />
          <ConcatInfoCard :contact="orderData.contact" />
          <button @click="toPay"  v-if="orderData.orderInfo && orderData.orderInfo.orderStatus == 'WP'" :disabled="orderCanPay" :class="['next-step', !intervalTime.length ? 'step-disabled' : '']">
            去支付
            <span style="color: #ffffff" v-if="intervalTime.length > 0">(剩余{{ intervalTime }})</span>
          </button>
        </div>
        <div v-if="activeIndex == 3">
          <div class="booked-ticket">
            <div class="info-text">
              <span class="info-text-title">支付信息</span>
              <div class="info-text-content">
                <p>请您在新打开的网上银行页面进行支付，支付完成前请不要关闭该窗口</p>
                <p>若您的银行付款页面没有打开，请检查并设置您的浏览器“允许弹出”</p>
                <p>若您的银行卡或账户已被扣款，但订单没有支付成功，这可能是网络传输问题造成</p>
                <p>湖南航空将尽快为您出票，网站会通过短信及邮件告知出票情况，请您保持关注</p>
                <p>
                  如遇问题，可拨打湖南航空客服热线
                  <span class="warning">4008337777</span>
                </p>
              </div>
            </div>
          </div>
          <span class="order-footer">
            <span class="order-success" @click="paySuccess">支付成功</span>
            <span class="order-failed" @click="payFail">支付失败，继续支付</span>
          </span>
        </div>
      </div>
      <IntFeePanel :journeySegments="orderData.journeySegments || []" :payTotalInfo="payTotalInfo" :productInfo="orderData.ruleInfo" />
    </div>
  </div>
</template>

<script>
import IntFeePanel from "@/views/components/intFeePanel.vue";
import ProgressBar from "@/components/ProgressBar";

import OrderInfoCard from '@/views/order/components/OrderInfoCard.vue';
import PassengerInfoCard from '@/views/order/components/PassengerInfoCard.vue';
import ConcatInfoCard from '@/views/order/components/ConcatInfoCard.vue';

import { queryIntOrderDetail, orderCancel } from "@/api/newsapi";

export default {
  name: "IntOrderReview",
  components: { ProgressBar, IntFeePanel, OrderInfoCard, PassengerInfoCard, ConcatInfoCard },
  data() {
    return {
      activeIndex: 2,
      flightPayInfo: {},
      intervalTime: "",
      orderNo: '',
      orderData: {},
      loading: false,
      orderCanPay: false,
      timeInterval: null
    };
  },

  computed: {
    payTotalInfo() {
      return {
        totalAmount: this.orderData?.orderInfo?.orderAmount || 0, 
        passengerGroupList: this.orderData?.priceInfos || []
      }
    },
  },

  mounted() {
    this.orderNo = this.$route.params.orderNo;
    this.getOrderDetail(this.orderNo);
  },
  methods: {
    toPay() {
      console.log("支付检测");
      this.activeIndex = 3;
      window.open( "/route/casherpay?bank=alipay&orderNo=" + this.orderNo, "_blank" );
    },
    payFail() {
      this.activeIndex = 2;
      this.getOrderDetail(this.orderNo);
    },
    paySuccess() {
      this.activeIndex = 2;
      this.$router.push({
        path: "/order/intPayDetail/" + this.orderNo,
        query: { t: new Date().getTime() },
      });
    },
    gotoCancelOrder() {
      this.$confirm("当前座位紧张，请确认是否立即取消此订单？", "温馨提示", {
        distinguishCancelAndClose: true,
        center: false,
        confirmButtonText: "立即取消",
        cancelButtonText: "再等一等",
        cancelButtonClass: "cancelBtn",
        customClass: "m-message-box",
      }).then(() => {
        this.cancelOrderHandler(this.orderNo);
      });
    },
    cancelOrderHandler(orderNo) {
      this.loading = true;
      orderCancel({ t: orderNo }).then((res) => {
        if (res.success) {
          this.getOrderDetail(orderNo);
        } else {
          this.$message.error(res.errorMessage);
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      })
    },
    getOrderDetail(serialNo) {
      this.loading = true;
      queryIntOrderDetail({ serialNo }).then((res) => {
        if (res.success) {
          this.orderData = res.data;
          this.payInterval();
        } else {
          this.$message.error(res.errorMessage);
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    payInterval() {
      if(this.timeInterval) {
        clearInterval(this.timeInterval);
        this.timeInterval = null;
      }
      this.timeInterval = setInterval(() => {
        const payTimeLimit = this.orderData.orderInfo?.payTimeLimit || 0;
        const remainMs = payTimeLimit - new Date().getTime();
        if (remainMs <= 0) {
          clearInterval(this.timeInterval);
          this.intervalTime = "";
          this.orderCanPay = true;
          return;
        }
        this.intervalTime = this.formatDuring(remainMs);
      }, 1000);
    },
    formatDuring(mss) {
      var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = (mss % (1000 * 60)) / 1000;
      seconds = parseInt(seconds);
      return minutes + " 分 " + seconds + " 秒 ";
    },
    
  }
};
</script>

<style lang="less" scoped>
.int-order-review {
  background-color: #f9f9f9;
  .container {
    position: relative;
    display: flex;
    padding: 16px 0;
    gap: 16px;
    .mb-16 {
      margin-bottom: 16px;
    }
    .info-panel {
      width: 756px;
      .cancel-order-btn {
        width: 50px;
        background-color: #d70039;
        color: #ffffff;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
        position: absolute;
        right: 16px;
        top: 16px;
        padding: 4px 8px;
        &:hover {
          opacity: 0.8;
        }
      }
      .next-step {
        width: 100%;
        height: 53px;
        border: 0;
        background-color: #d70039;
        color: #fff;
        font-size: 16px;
        margin: 42px 0 53px;
        cursor: pointer;
      }
      .next-step:active {
        background-color: #b11e45;
      }
      .step-disabled {
        background-color: #ccc;
      }
      .step-disabled.next-step:active {
        background-color: #ccc;
      }

      .booked-ticket {
        background: #ffffff;
        // border: 1px solid #ededed;
        border-radius: 8px;
      }

      .info-text {
        padding: 16px;
        &-title {
          font-weight: bold;
          font-size: 22px;
          color: #4d4e4e;
          margin-bottom: 10px;
          display: block;
        }
        &-content {
          line-height: 46px;
        }
        .warning {
          color: #d70039;
        }
      }
      .order-footer {
        width: 100%;
        display: flex;
        justify-content: space-between;
        gap: 20px;
        margin-top: 20px;
      }
      .order-success,
      .order-failed {
        width: 50%;
        padding: 2px 5px;
        background: #d70039;
        border: 1px solid #d70039;
        color: #fff;
        border-radius: 5px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
      .order-failed {
        background: #ffffff;
        color: #333333;
        border: 1px solid #d70039;
      }
      .order-failed:active {
        background: #eee;
      }
      .order-success:active {
        background-color: #b11e45;
      }
    }
  }
}
</style>
